import { render } from "./GoToClaimModal.vue?vue&type=template&id=76404fee"
import script from "./GoToClaimModal.vue?vue&type=script&lang=js"
export * from "./GoToClaimModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__